import { useState, useEffect, useCallback } from "react";
import {
  IPerformanceMetricInput,
  UserInterface,
  ICountry,
} from "../../../interface";
import CountryFilter from "../../../components/CountryFilter";
import { Category } from "../../../interface/Enums/category.enum";
import { PerfType } from "../../../interface/Enums/peftype.enum";
import { useDispatch, useSelector } from "react-redux";
import { getAllCountries } from "../../../APIs";
import { fetchAPI } from "../../../utils/FetchApi";
import { FetchMethods } from "../../../interface/Enums/methods.enum";
import { setError } from "../../../store/reducers/errorReducer";
import Dropdown from "react-bootstrap/Dropdown";
import { BsThreeDotsVertical } from "react-icons/bs";
import Badge from "react-bootstrap/Badge";
import Accordion from "react-bootstrap/Accordion";
import AdminContainer from "../../../admin-components/AdminContainer";
import { Modal, BtnCreate } from "../../../components/StyledComponents";
const ManagePerformanceInputMetrics = () => {
  const dispatch:any = useDispatch();
  const data: UserInterface = useSelector((data: any) => {
    return data.auth.user;
  });

  const [listOfCountries, setlistOfCountries] = useState<ICountry[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const [performanceMetrics, setPerformanceMetrics] = useState<
    IPerformanceMetricInput[]
  >([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [formData, setFormData] = useState<IPerformanceMetricInput>({
    name: "",
    explanation: "",
    category: Category.INPUT,
    type: PerfType.STANDARD,
    country: "",
    importance: 1,
    createdAt: new Date(),
    updatedAt: new Date(),
    creator: (data?.name && data?.surname) ? data.name + " " + data.surname : "",
    _id: ""
  });
  const resetForm = () => {
    setFormData({
      name: "",
      explanation: "",
      category: Category.INPUT,
      type: PerfType.STANDARD,
      country: "",
      importance: 1,
      createdAt: new Date(),
      updatedAt: new Date(),
      creator: (data?.name && data?.surname) ? data.name + " " + data.surname : "",
      _id: ""
    });
  };

  const openCreateModal = () => {
    const currentCreator = (data?.name && data?.surname) ? data.name + " " + data.surname : "";
    setFormData({
      name: "",
      explanation: "",
      category: Category.INPUT,
      type: PerfType.STANDARD,
      country: "",
      importance: 1,
      createdAt: new Date(),
      updatedAt: new Date(),
      creator: currentCreator,
      _id: ""
    });
    setIsEditMode(false);
    setShowModal(true);
  };

  const openEditModal = (metric: IPerformanceMetricInput) => {
    setFormData(metric);
    setIsEditMode(true);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setIsEditMode(false);
    resetForm();
  };

  const handleSubmit = async () => {
    // Validation
    if(formData.name.length===0 || formData.country.length===0 || formData.country === "---" || formData.creator.length===0 || formData.explanation.length===0 || formData.importance<1 || formData.importance>100){
      dispatch(setError("Please fill in all the fields correctly - name, country, creator, explanation must not be empty and importance must have a value from 1 to 100"));
      return;
    }

    try {
      let result: IPerformanceMetricInput[];
      
      if (isEditMode) {
        // For update, send the full formData including _id
        result = await fetchAPI("/admincmds/update-performance-input-metric", FetchMethods.PATCH, formData);
      } else {
        // For create, only send the necessary fields (exclude _id, createdAt, updatedAt)
        const createData = {
          name: formData.name,
          explanation: formData.explanation,
          category: formData.category,
          type: formData.type,
          country: formData.country,
          importance: formData.importance,
          creator: formData.creator
        };
        result = await fetchAPI("/admincmds/create-performance-input-metric", FetchMethods.POST, createData);
      }
      
      setPerformanceMetrics(result);
      closeModal();
    } catch (error: any) {
      dispatch(setError(error.message?.toString() || error.toString()));
    }
  };

  const deletePerformanceMetric = async (index: number) => {
    //confirm delete
    if(!window.confirm("Are you sure you want to delete this performance metric?"))return;

    try {
      const listOfAllInputs: IPerformanceMetricInput[] = await fetchAPI(
        `/admincmds/delete-performance-input-metric/${performanceMetrics[index]._id}`,
        FetchMethods.GET
      );
      if (listOfAllInputs.hasOwnProperty("error")) {
        //@ts-ignore
        throw new Error(listOfAllInputs.message?.toString());
      }

      setPerformanceMetrics(listOfAllInputs);
    } catch (error: any) {
      dispatch(setError(error.toString()));
    }
  };
  
  const pickCountry = useCallback((country: string): void => {
    setSelectedCountry(country);
  }, []);

  /**
   * Use Effects
   */
  useEffect(() => {
    (async () => {
      const ctries: ICountry[] = await getAllCountries();
      ctries.sort((a, b) => (a.name > b.name ? 1 : -1));
      setlistOfCountries(ctries);
    })();
  }, []);

  //Load all inputs based on the country
  useEffect(() => {
    if(selectedCountry.length>0){
      (async () => {
        try {
          const getAllInputs: IPerformanceMetricInput[] = await fetchAPI(
            `/admincmds/get-all-performance-input-metrics/${selectedCountry}`,
            FetchMethods.GET
          );
          if (getAllInputs.hasOwnProperty("error")) {
            throw new Error(JSON.stringify(getAllInputs));
          }
          setPerformanceMetrics(getAllInputs);
        } catch (error: any) {
          dispatch(JSON.stringify(error.message));
        }
      })();
    }
 
    //do nothing yet
  }, [selectedCountry, dispatch]);
  
  return (
    <AdminContainer>
      <div className="row justify-content-between align-items-center">
        <div className="col-lg-8 m-2">
        <CountryFilter returnedCountry={pickCountry} />
        </div>
        <div className="col-lg-2 m-2">
              <BtnCreate onClick={openCreateModal}>
                Create new Performance Metric
              </BtnCreate>
        </div>
      </div>
<hr className="hr" />
      <div className="row justify-content-md-center">
        {performanceMetrics.length > 0 && performanceMetrics.map((c: IPerformanceMetricInput, i: number) => (
          <div className="card col-lg-3 col-md-4 cal-sm-2 m-2" key={i}>
            <div className="row flex-row-reverse">
              <div className="m-2">
                <Dropdown>
                  <Dropdown.Toggle size="sm" variant="info">
                    <BsThreeDotsVertical />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      href="#/action-1"
                      onClick={() => {
                        openEditModal(performanceMetrics[i]);
                      }}
                    >
                      Update
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#/action-2"
                      onClick={() => {
                        deletePerformanceMetric(i);
                      }}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="row">
              <div className="row m-1">
                <Badge
                  bg={c.category === "input" ? "secondary" : "success"}
                  className="col-lg-3 m-1 p-1"
                >
                  {c.category}
                </Badge>
                <Badge
                  bg={c.type === "standard" ? "info" : "danger"}
                  className="col-lg-3 m-1 p-1"
                >
                  {c.type}
                </Badge>
                <Badge bg="warning" className="col-lg-3 m-1 p-1">
                  {c.importance}%
                </Badge>
              </div>
              <Accordion>
                <Accordion.Item eventKey={i.toString()}>
                  <Accordion.Header>
                    <small className="m-2" style={{ fontWeight: "bold" }}>
                      {c.name}
                    </small>
                  </Accordion.Header>
                  <Accordion.Body key={i}>
                    <strong>Explanation:</strong>
                    <p>{c.explanation}</p>
                    <br />
                    <Badge bg="secondary">By: {c.creator}</Badge>
                    <br />
                    <Badge bg="secondary">Country scope: {c.country}</Badge>
                    <br />
                    <Badge bg="secondary">Importance: {c.importance}%</Badge>
                    <br />
                    <Badge bg="secondary">Category: {c.category}</Badge>
                    <br />
                    <Badge bg="secondary">Type: {c.type}</Badge>
                    <br />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        ))}
      </div>
      {/* Unified Modal for Create/Update */}
      <Modal isOpen={showModal} onClose={closeModal}>
        <div className="row">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <div className="row" style={{ marginTop: 20 }}>
              <div className="form-group">
                <div className="card" style={{ padding: 30 }}>
                  {isEditMode && (
                    <h1 className="bold small text-center shadow p-4 m-4">
                      You are updating <span className="text-info">{formData.name}</span> | <span className="text-danger">{formData._id}</span>
                    </h1>
                  )}
                  
                  <div className="row p-4 m-4 shadow rounded">
                    <div className="col-4">
                      <h3>{isEditMode ? 'Update' : ''} Metric Name</h3>
                    </div>
                    <div className="col-6">
                      <input
                        className="form-control"
                        type="text"
                        value={formData.name}
                        onChange={({ target }) => {
                          setFormData({
                            ...formData,
                            name: target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="row p-4 m-4 shadow rounded">
                    <div className="col-4">
                      <h3>{isEditMode ? 'Update' : ''} Metric Explanation</h3>
                    </div>
                    <div className="col-6">
                      <input
                        className="form-control"
                        type="text"
                        value={formData.explanation}
                        onChange={({ target }) => {
                          setFormData({
                            ...formData,
                            explanation: target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="row p-4 m-4 shadow">
                    <div className="col-4">
                      <h3>{isEditMode ? 'Update' : ''} Metric Type</h3>
                    </div>
                    <div className="col-6">
                      <select
                        className="form-control"
                        value={formData.type}
                        onChange={({ target }) => {
                          setFormData({
                            ...formData,
                            //@ts-ignore
                            type: target.value,
                          });
                        }}
                      >
                        <option
                          className="form-control"
                          value={PerfType.STANDARD}
                        >
                          {PerfType.STANDARD}
                        </option>
                        <option
                          className="form-control"
                          value={PerfType.ENERGIZER}
                        >
                          {PerfType.ENERGIZER}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="row p-4 m-4 shadow rounded">
                    <div className="col-4">
                      <h3>{isEditMode ? 'Update' : ''} Importance (%)</h3>
                      <p className="small">Insert number only from 0-100!</p>
                    </div>
                    <div className="col-6">
                      <input
                        value={formData.importance}
                        max={100}
                        min={0}
                        defaultValue={1}
                        className="form-control"
                        type="number"
                        onChange={({ target }) => {
                          setFormData({
                            ...formData,
                            importance: parseInt(target.value),
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="row p-4 m-4 shadow rounded">
                    <div className="col-4">
                      <h3>{isEditMode ? 'Update' : ''} Country</h3>
                    </div>
                    <div className="col-6">
                      <select
                        className="form-control"
                        value={formData.country}
                        onChange={({ target }) => {
                          setFormData({
                            ...formData,
                            country: target.value,
                          });
                        }}
                      >
                        {!isEditMode && (
                          <option className="form-control" value="---">
                            ---
                          </option>
                        )}
                        {listOfCountries.map((c: ICountry, i: number) => (
                          <option className="form-control" key={i} value={c.name}>
                            {c.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col p-4 m-4 shadow rounded">
                    <h3 className="text-center">Creator</h3>
                    <input
                      className="form-control"
                      type="text"
                      readOnly
                      value={formData.creator}
                      style={{ backgroundColor: "#d6d6d6", textAlign: "center" }}
                    />
                  </div>

                  <div className="row">
                    <button 
                      type="submit" 
                      className="dai-btn dai-btn-success"
                    >
                      {isEditMode ? `Update ${formData.name}` : 'Create'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </AdminContainer>
  );
};

export default ManagePerformanceInputMetrics;